import styled from 'styled-components'
import { Neutral } from 'assets/styled-component/variables'

export const DivGoToDigitalAccount = styled.a`
  background-color: ${Neutral};
  border: 1px solid #dedfe4;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  margin-bottom: 56px;
  justify-content: space-between;
  cursor: pointer;
`
export const DivTextGoToDigitalAccount = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`
